export class CoverageInfoCapital {
  sumInsured: string

  constructor(data: any = {}) {
    this.sumInsured = data.sumInsured
  }
}
